import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';

import { RoomManagerService } from '../room/room-manager.service';
import { ReplayerService, OnReplayer } from '../../player/replayer.service';
import { PermissionsParserService } from '../permissions/permissions-parser.service';
import { IPermissionsManager } from '../permissions/permissions-manager';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { WsService2 } from '../ws/ws.service';
export enum Log{
     MEDIA, ICE_CANDIDATE, OTHER
}
@Injectable()
export class LogService  {
    
	constructor(private http:Http,  private wsService: WsService2) {
      
    }

    logs=[]
    logMedia(log, obj=null){
        if (obj!=null){
            try{
                log+=JSON.stringify(obj);
            }catch(err){
                log+=" THERE WAS object but could not be serialised";
            }
        }
        this.log(log, Log.MEDIA)
    }
    log(log, type=Log.OTHER){
        console.log(log);
        this.logs.push({type: type, log: log})
    }
    sendlog(){
        if (this.logs.length==0)return;
        var logs = this.logs.slice();
        
        var url = environment.wbBackendUrl + "log";
        console.log("Will send logs ",this.logs);
       this.http.post(url, {userHash: this.wsService.getMe(), logs: logs})
      .subscribe(data => {
          console.log("Logs got, currently they are ",this.logs);
        this.logs.splice(0, logs.length);
        console.log("After removal they are ", this.logs);
      });
    }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/log/log.service.ts